// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__LIS6L","load2":"Spinner_load2__XlSsT"};